var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form",
        { staticClass: "mt-2" },
        [
          _c(
            "b-form-row",
            [
              _c(
                "b-col",
                { staticClass: "col-form-label px-3", attrs: { cols: "3" } },
                [
                  _c("label", { staticClass: "w-100 text-right" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "message.contractInformationForm.label.contractCategory"
                          )
                        ) +
                        "\n          "
                    ),
                    _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "px-3", attrs: { cols: "9" } },
                [
                  _c(
                    "b-form-select",
                    {
                      ref: "contractCategory",
                      staticClass: "rounded-0",
                      attrs: {
                        id: "contractCategory",
                        value: _vm.contract.contractCategory,
                        state: _vm.$v.contract.contractCategory.$error
                          ? false
                          : null
                      },
                      on: { change: _vm.contractCategoryChanged }
                    },
                    [
                      _c("template", { slot: "first" }, [
                        _c(
                          "option",
                          {
                            attrs: { disabled: "" },
                            domProps: { value: null }
                          },
                          [
                            _vm._v(
                              "-- " +
                                _vm._s(
                                  this.$t(
                                    "message.contractInformationForm.option.null"
                                  )
                                ) +
                                " --"
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.contractCategories, function(
                        contractCategory
                      ) {
                        return _c(
                          "option",
                          {
                            key: contractCategory.value,
                            domProps: { value: contractCategory.value }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(contractCategory.text) +
                                "\n          "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                { staticClass: "col-form-label px-3", attrs: { cols: "3" } },
                [
                  _c("label", { staticClass: "w-100 text-right" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "message.contractInformationForm.label.contractType"
                          )
                        ) +
                        "\n          "
                    ),
                    _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "px-3", attrs: { cols: "9" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        state: _vm.$v.contract.contractType.$error
                          ? false
                          : null,
                        "invalid-feedback": _vm.$t(
                          "error.contractInformationForm.contractType"
                        )
                      }
                    },
                    [
                      _c("b-input", {
                        staticClass: "rounded-0",
                        attrs: {
                          id: "contractType",
                          placeholder: _vm.getPlaceholderLabel(
                            _vm.contract.contractCategory
                          ),
                          state: _vm.$v.contract.contractType.$error
                            ? false
                            : null
                        },
                        on: {
                          change: function($event) {
                            _vm.$v.contract.contractType.$touch()
                          }
                        },
                        model: {
                          value: _vm.contract.contractType,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "contractType", $$v)
                          },
                          expression: "contract.contractType"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.contract.contractCategory ===
          "ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT"
            ? _c(
                "b-form-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "col-form-label px-3",
                      attrs: { cols: "3" }
                    },
                    [
                      _c("label", { staticClass: "w-100 text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.contractInformationForm.label.username"
                            )
                          ) + "\n          "
                        ),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "px-3", attrs: { cols: "9" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            state: _vm.$v.contract.accountUsername.$error
                              ? false
                              : null,
                            "invalid-feedback": _vm.$t(
                              "error.contractInformationForm.username"
                            )
                          }
                        },
                        [
                          _c("b-input", {
                            staticClass: "rounded-0",
                            attrs: {
                              id: "username",
                              state: _vm.$v.contract.accountUsername.$error
                                ? false
                                : null
                            },
                            on: {
                              change: function($event) {
                                _vm.$v.contract.accountUsername.$touch()
                              }
                            },
                            model: {
                              value: _vm.contract.accountUsername,
                              callback: function($$v) {
                                _vm.$set(_vm.contract, "accountUsername", $$v)
                              },
                              expression: "contract.accountUsername"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.contract.contractCategory ===
          "ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT"
            ? _c(
                "b-form-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "col-form-label px-3",
                      attrs: { cols: "3" }
                    },
                    [
                      _c("label", { staticClass: "w-100 text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.contractInformationForm.label.link")
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "px-3", attrs: { cols: "9" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            state: _vm.$v.contract.accountLink.$error
                              ? false
                              : null,
                            "invalid-feedback": _vm.$t(
                              "error.contractInformationForm.link"
                            )
                          }
                        },
                        [
                          _c("b-input", {
                            staticClass: "rounded-0",
                            attrs: {
                              id: "link",
                              state: _vm.$v.contract.accountLink.$error
                                ? false
                                : null
                            },
                            on: {
                              change: function($event) {
                                _vm.$v.contract.accountLink.$touch()
                              }
                            },
                            model: {
                              value: _vm.contract.accountLink,
                              callback: function($$v) {
                                _vm.$set(_vm.contract, "accountLink", $$v)
                              },
                              expression: "contract.accountLink"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.contract.contractCategory !==
          "ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT"
            ? _c(
                "b-form-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "col-form-label px-3",
                      attrs: { cols: "3" }
                    },
                    [
                      _c("label", { staticClass: "w-100 text-right" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.contractNumberText) +
                            "\n          "
                        ),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "px-3", attrs: { cols: "9" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            state: _vm.$v.contract.contractNumber.$error
                              ? false
                              : null,
                            "invalid-feedback": _vm.$t(
                              "error.contractInformationForm.contractNumber"
                            )
                          }
                        },
                        [
                          _c("b-input", {
                            staticClass: "rounded-0",
                            attrs: {
                              id: "contractNumber",
                              placeholder: _vm.$t(
                                "message.contractInformationForm.contractPlaceholder.universal.exampleUserContractNumber"
                              ),
                              state: _vm.$v.contract.contractNumber.$error
                                ? false
                                : null
                            },
                            on: {
                              change: function($event) {
                                _vm.$v.contract.contractNumber.$touch()
                              }
                            },
                            model: {
                              value: _vm.contract.contractNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.contract, "contractNumber", $$v)
                              },
                              expression: "contract.contractNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.contract.contractCategory === "INSURANCE"
            ? _c(
                "b-form-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "col-form-label px-3",
                      attrs: { cols: "3" }
                    },
                    [
                      _c("label", { staticClass: "w-100 text-right" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "message.contractInformationForm.label.insuredPersonNumber"
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "px-3", attrs: { cols: "9" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            state: _vm.$v.contract.insuredPersonNumber.$error
                              ? false
                              : null,
                            "invalid-feedback": _vm.$t(
                              "error.contractInformationForm.insuredPersonNumber"
                            )
                          }
                        },
                        [
                          _c("b-input", {
                            staticClass: "rounded-0",
                            attrs: {
                              id: "policy-holder-number",
                              placeholder: _vm.$t(
                                "message.contractInformationForm.contractPlaceholder.universal.exampleUserContractNumber"
                              ),
                              state: _vm.$v.contract.insuredPersonNumber.$error
                                ? false
                                : null
                            },
                            on: {
                              change: function($event) {
                                _vm.$v.contract.insuredPersonNumber.$touch()
                              }
                            },
                            model: {
                              value: _vm.contract.insuredPersonNumber,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.contract,
                                  "insuredPersonNumber",
                                  $$v
                                )
                              },
                              expression: "contract.insuredPersonNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.contract.contractCategory === "FINANCE"
            ? _c(
                "b-form-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "col-form-label px-3",
                      attrs: { cols: "3" }
                    },
                    [
                      _c("label", { staticClass: "w-100 text-right" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "message.contractInformationForm.label.accountNumber"
                              )
                            ) +
                            "\n          "
                        ),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "px-3", attrs: { cols: "9" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            state: _vm.$v.contract.accountNumber.$error
                              ? false
                              : null,
                            "invalid-feedback": _vm.$t(
                              "error.contractInformationForm.accountNumber"
                            )
                          }
                        },
                        [
                          _c("b-input", {
                            staticClass: "rounded-0",
                            attrs: {
                              id: "account-number",
                              placeholder: _vm.$t(
                                "message.contractInformationForm.contractPlaceholder.universal.exampleUserContractNumber"
                              ),
                              state: _vm.$v.contract.accountNumber.$error
                                ? false
                                : null
                            },
                            on: {
                              change: function($event) {
                                _vm.$v.contract.accountNumber.$touch()
                              }
                            },
                            model: {
                              value: _vm.contract.accountNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.contract, "accountNumber", $$v)
                              },
                              expression: "contract.accountNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.contract.contractCategory !==
          "ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT"
            ? _c(
                "b-form-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "col-form-label px-3",
                      attrs: { cols: "3" }
                    },
                    [
                      _c("label", { staticClass: "w-100 text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.contractInformationForm.label.conclusionDate"
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "px-3", attrs: { cols: "9" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            state: _vm.$v.conclusionDate.$error ? false : null,
                            "invalid-feedback": _vm.$t(
                              "error.contractInformationForm.conclusionDate"
                            )
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "rounded-0",
                            attrs: {
                              id: "conclusionDate",
                              placeholder: "TT.MM.JJJJ",
                              state: _vm.$v.conclusionDate.$error ? false : null
                            },
                            on: {
                              change: function($event) {
                                _vm.$v.conclusionDate.$touch()
                              }
                            },
                            model: {
                              value: _vm.conclusionDate,
                              callback: function($$v) {
                                _vm.conclusionDate = $$v
                              },
                              expression: "conclusionDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.contract.contractCategory !==
          "ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT"
            ? _c(
                "b-form-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "col-form-label px-3",
                      attrs: { cols: "3" }
                    },
                    [
                      _c("label", { staticClass: "w-100 text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.contractInformationForm.label.contractDuration"
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "px-3", attrs: { cols: "9" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            state: _vm.$v.contract.contractDuration.$error
                              ? false
                              : null,
                            "invalid-feedback": _vm.$t(
                              "error.contractInformationForm.contractDuration"
                            )
                          }
                        },
                        [
                          _c(
                            "b-input-group",
                            {
                              attrs: {
                                append: _vm.$t(
                                  "message.contractInformationForm.label.inMonths"
                                )
                              }
                            },
                            [
                              _c("b-input", {
                                staticClass: "rounded-0",
                                attrs: {
                                  id: "contractDuration",
                                  type: "number",
                                  min: "0",
                                  state: _vm.$v.contract.contractDuration.$error
                                    ? false
                                    : null
                                },
                                on: {
                                  change: function($event) {
                                    _vm.$v.contract.contractDuration.$touch()
                                  }
                                },
                                model: {
                                  value: _vm.contract.contractDuration,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contract,
                                      "contractDuration",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "contract.contractDuration"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.contract.contractCategory !==
          "ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT"
            ? _c(
                "b-form-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "col-form-label px-3",
                      attrs: { cols: "3" }
                    },
                    [
                      _c("label", { staticClass: "w-100 text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.contractInformationForm.label.cancellationPeriod"
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "px-3", attrs: { cols: "9" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            state: _vm.$v.contract.cancellationPeriod.$error
                              ? false
                              : null,
                            "invalid-feedback": _vm.$t(
                              "error.contractInformationForm.cancellationPeriod"
                            )
                          }
                        },
                        [
                          _c(
                            "b-input-group",
                            {
                              attrs: {
                                append: _vm.$t(
                                  "message.contractInformationForm.label.inMonths"
                                )
                              }
                            },
                            [
                              _c("b-input", {
                                staticClass: "rounded-0",
                                attrs: {
                                  id: "cancellationPeriod",
                                  type: "number",
                                  min: "0",
                                  state: _vm.$v.contract.cancellationPeriod
                                    .$error
                                    ? false
                                    : null
                                },
                                on: {
                                  change: function($event) {
                                    _vm.$v.contract.cancellationPeriod.$touch()
                                  }
                                },
                                model: {
                                  value: _vm.contract.cancellationPeriod,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contract,
                                      "cancellationPeriod",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "contract.cancellationPeriod"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-form-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                { staticClass: "col-form-label px-3", attrs: { cols: "3" } },
                [
                  _c("label", { staticClass: "w-100 text-right" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("message.contractInformationForm.label.comment")
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "px-3", attrs: { cols: "9" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        state: _vm.$v.contract.comment.$error ? false : null,
                        "invalid-feedback": _vm.$t(
                          "error.contractInformationForm.comment"
                        )
                      }
                    },
                    [
                      _c("b-form-textarea", {
                        staticClass: "rounded-0",
                        attrs: {
                          id: "comment",
                          rows: 5,
                          "max-rows": 5,
                          state: _vm.$v.contract.comment.$error ? false : null
                        },
                        on: {
                          change: function($event) {
                            _vm.$v.contract.comment.$touch()
                          }
                        },
                        model: {
                          value: _vm.contract.comment,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "comment", $$v)
                          },
                          expression: "contract.comment"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            [
              _c(
                "b-col",
                { staticClass: "col-form-label px-3 ", attrs: { offset: "3" } },
                [
                  _c("div", { staticClass: "requieredFields text-right" }, [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t(
                            "message.contractPartnerDetails.label.requiredFields"
                          )
                        )
                      }
                    })
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "contractCategoryModal",
          attrs: {
            id: "contractCategoryModal",
            "modal-class": "rounded-0",
            title: _vm.$t(
              "message.contractInformationForm.contractCategoryModal.title"
            ),
            "ok-title": _vm.$t(
              "message.contractInformationForm.contractCategoryModal.btn.ok"
            ),
            "cancel-title": _vm.$t(
              "message.contractInformationForm.contractCategoryModal.btn.cancel"
            )
          },
          on: {
            ok: _vm.setContractCategory,
            cancel: _vm.revertContractCategory
          }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t(
                  "message.contractInformationForm.contractCategoryModal.message"
                )
              ) +
              "\n  "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f135a30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f135a30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contracts/ContractInformationForm.vue
// module id = lB92
// module chunks = 1